import React, { FC } from 'react'
import { PointIcon } from './Icon'
import { Wrapper, Text, TextColor } from './styled'

interface ComponentProps {
	text: string
	textColor: string
}

export const PointWithElement: FC<ComponentProps> = ({ text, textColor }) => (
	<Wrapper>
		<PointIcon />
		<Text>
			<TextColor href={`tel:${textColor.trim()}`}>{textColor}</TextColor>
			{text}
		</Text>
	</Wrapper>
)
